import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { faPaperPlaneTop } from '@fortawesome/pro-regular-svg-icons';
import { PopupNotificationManager } from '@realwear-cloud/shared/ui-kit';
import { HubspotSubmitterService } from './hubspot-submitter.service';

@Component({
  selector: 'realwear-cloud-hubspot-subscribe-dialog',
  templateUrl: './hubspot-subscribe-dialog.component.html',
  styleUrls: ['./hubspot-subscribe-dialog.component.scss']
})
export class HubspotSubscribeDialogComponent {
  readonly formGroup: FormGroup;
  readonly faPaperPlane = faPaperPlaneTop;

  constructor(
    private submitter: HubspotSubmitterService,
    private matDialogRef: MatDialogRef<unknown>,
    private notifications: PopupNotificationManager
  ) {
    this.formGroup = new FormGroup({
      email: new FormControl<string | null>(null, [Validators.required, Validators.email]),
      consent: new FormControl<boolean>(false, [Validators.requiredTrue])
    });
  }

  async onSubmit() {
    if (this.formGroup.invalid) {
      return;
    }

    const notification = this.notifications.addNotification({ state: 'loading', text: 'Subscribing...' });

    const email = this.formGroup.get('email')?.value;

    this.formGroup.disable();

    try {
      await this.submitter.subscribeToNewsletter(email);

      notification.updateConfig({ state: 'success', text: 'Subscribed!' });
    } catch {
      notification.updateConfig({ state: 'failed', text: 'Failed to subscribe!' });

      this.formGroup.enable();
      return;
    }

    this.matDialogRef.close();
  }
}
